export const square = {
	name: 'square',
	title: 'Unselected',
	content:
		'<path d="M0.750 0.749 L23.250 0.749 L23.250 23.249 L0.750 23.249 Z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"></path>',
};
